import { Typography } from 'components/Contentful'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { Divider } from '@achieve/ascend'
import { mainProductConfig } from 'services/contentful/helpers'
import { useContext } from 'react'
import { LayoutContext } from 'providers/LayoutProvider'

function AuthorLinks({ links, title, buttons }) {
  const { state: { siteEnv } = {} } = useContext(LayoutContext)
  return (
    <div className={''}>
      {title ? (
        title
      ) : (
        <Typography
          content={'Other publications'}
          className={'mb-6 md:mb-8 headingMd lg:displayMd font-medium lg:font-light'}
        />
      )}
      {links &&
        links.map((link, linkIndex) => {
          return (
            <div className={'mb-8 last:mb-0'} key={linkIndex} data-testid="single-link-container">
              <div className={'mb-6'}>
                <AchieveLink
                  href={link?.fields?.linkHref}
                  target="__blank"
                  rel="noopener noreferrer nofollow"
                  noLink
                  className={'hover:decoration-neutral-900'}
                  track={{
                    list_name: 'Right Rail Title',
                    click_id: link?.linkText?.json?.content?.[0]?.content?.[0]?.value,
                    click_position: linkIndex,
                    click_text: `${
                      mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                    } | ${link?.fields?.linkText?.json?.content?.[0]?.content?.[0]?.value}`,
                    nav_link_section: 'Suggested Content - Right Rail',
                    track_event: 'page_nav_click',
                    event_action: 'link_click',
                    event_type: 'link_click',
                  }}
                  data-testid="related-title-link"
                >
                  <Typography
                    content={link?.fields?.linkText}
                    variant="bodyLg"
                    className={'text-neutral-900 inline'}
                    fontWeight="medium"
                  />
                </AchieveLink>
              </div>

              <AchieveLink
                href={link?.fields?.linkHref}
                target="__blank"
                rel="noopener noreferrer nofollow"
                noLink
                className={'inline-block'}
                track={{
                  list_name: 'Right Rail Read More',
                  click_id: title,
                  click_position: 'Read the article',
                  click_text: `${
                    mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                  } | Read the article`,
                  nav_link_section: 'Suggested Content - Right Rail',
                  track_event: 'page_nav_click',
                  event_action: 'link_click',
                  event_type: 'link_click',
                }}
                data-testid="related-cta-link"
              >
                <Typography
                  content={buttons ? buttons : 'Read the link'}
                  variant="bodyLg"
                  fontWeight="bold"
                />
              </AchieveLink>

              {linkIndex !== links.length - 1 && <Divider className={'mt-8'} />}
            </div>
          )
        })}
    </div>
  )
}

export { AuthorLinks }
